import { Col, Container, Label, Row } from "reactstrap";
import Badge from "react-bootstrap/Badge";

import useDisplayDataStyles from "./styles";
import { ImageFileDto } from "../../../assets/utils/lib/imageFileDto";
import { FileHelper } from "../../../assets/utils/helpers/fileHelper";
import { Constants } from "../../../assets/utils/lib/constants";

interface DisplayDataProps {
  text?: string;
  importedData: string | ImageFileDto | undefined | null | any;
  hideColon?: boolean;
  isBold?: boolean;
  verticalCenter?: boolean;
  className?: string;
  layout?: "row" | "column";
  isImage?: boolean;
  imageStyle?: React.CSSProperties;
  isBubble?: boolean;
  height?: number;
}

const DisplayData = (props: DisplayDataProps) => {
  const displayDataStyles = useDisplayDataStyles();

  const containerStyles = {
    ...displayDataStyles.flex,
    ...displayDataStyles.row,
    flexDirection: props.layout === "column" ? "column" : "row",
    alignItems: props.verticalCenter ? "center" : "flex-start",
  } as React.CSSProperties;

  const colon = props.hideColon ? "" : ":";
  const isImage =
    props.importedData?.content !== null &&
    props.importedData?.content !== undefined;
  const imageDto: ImageFileDto | undefined = props.importedData as ImageFileDto;

  if (
    (props.importedData === Constants.emptyString ||
      props.importedData === null ||
      props.importedData === undefined) &&
    !isImage
  ) {
    return null;
  }

  const renderBubbles = () => {
    const values =
      typeof props.importedData === "string"
        ? props.importedData.split(",").map((v) => v.trim())
        : Array.isArray(props.importedData)
        ? props.importedData
        : [];

    return (
      <div className="d-flex flex-wrap gap-2">
        {values.map((item: string, i: number) => (
          <Badge key={i} pill bg="dark" className="px-3 py-2">
            {item}
          </Badge>
        ))}
      </div>
    );
  };

  const content = (
    <>
      <Label
        style={{
          ...displayDataStyles.label,
          ...(props.isBold === false ? {} : displayDataStyles.bold),
        }}
      >
        {props.text ? props.text + colon : null}
      </Label>
      <div
        style={{
          ...displayDataStyles.data,
          marginTop: props.layout === "row" ? "0" : "0",
        }}
      >
        {isImage && imageDto ? (
          <img
            src={FileHelper.FileToBase64String({ image: imageDto })}
            alt={imageDto.fileName || "Image"}
            style={{ maxWidth: "100%", height: "auto", ...props.imageStyle }}
          />
        ) : props.isBubble ? (
          renderBubbles()
        ) : (
          props.importedData
        )}
      </div>
    </>
  );

  if (props.layout === "column" || props.hideColon || !props.text) {
    return (
      <Container
        style={{ ...containerStyles, paddingLeft: 0, height: props.height }}
        className={props.className}
      >
        {content}
      </Container>
    );
  }

  return (
    <Container
      style={{ ...displayDataStyles.row, paddingLeft: 0, height: props.height }}
      className={props.className}
    >
      <Row className="align-items-start">
        <Col xs={12} md={3}>
          <Label
            style={{
              ...displayDataStyles.label,
              ...(props.isBold === false ? {} : displayDataStyles.bold),
            }}
          >
            {props.text + colon}
          </Label>
        </Col>
        <Col xs={12} md={9}>
          <div style={displayDataStyles.data}>
            {isImage && imageDto ? (
              <img
                src={FileHelper.FileToBase64String({ image: imageDto })}
                alt={imageDto.fileName || "Image"}
                style={{ maxWidth: "100%", height: "auto", ...props.imageStyle }}
              />
            ) : props.isBubble ? (
              renderBubbles()
            ) : (
              props.importedData
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DisplayData;
